import Cookies from 'js-cookie';

/**
 * Meta Pixel (dataset "Meu Treino"), only on meutreino.fit (the pt build sets VITE_META_PIXEL_ID) and only after
 * the visitor accepts cookies, exactly like Google (cookieConsent.js). Undecided or declined, nothing is requested
 * from Meta. The signup's CompleteRegistration carries the same event id the API sends through Meta's Conversions
 * API (meu-treino-api: extensions/users-permissions/meta-signup.js), so Meta counts it once.
 */
const pixelId = () => import.meta.env.VITE_META_PIXEL_ID;

// The route already counted, so client-side navigation sends one PageView per new page
let lastPath = null;

export const startMetaPixel = () => {
  const id = pixelId();
  if (!id) return;
  // Accepting again after a decline in the same visit
  if (window.fbq) {
    window.fbq('consent', 'grant');
    return;
  }
  // Meta's own stub: calls queue until fbevents.js arrives
  const fbq = function fbq() {
    // eslint-disable-next-line prefer-rest-params
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
    // eslint-disable-next-line prefer-rest-params
    else fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = 'true';
  document.head.appendChild(script);
  fbq('init', id);
  fbq('track', 'PageView');
};

// A decline after accepting: Meta stops receiving anything, and its cookies go
export const stopMetaPixel = () => {
  window.fbq?.('consent', 'revoke');
  ['_fbp', '_fbc'].forEach((name) => {
    Cookies.remove(name, { path: '/' });
    Cookies.remove(name, { path: '/', domain: `.${window.location.hostname}` });
  });
};

// Every route change after the first page (whose PageView startMetaPixel sends)
export const trackMetaRoute = (path) => {
  if (path === lastPath) return;
  const isFirst = lastPath === null;
  lastPath = path;
  if (!isFirst) window.fbq?.('track', 'PageView');
};

// After a successful signup; eventId is the one sent with the signup (acquisition.eventId)
export const trackMetaSignup = (eventId) => {
  if (!eventId) return;
  window.fbq?.('track', 'CompleteRegistration', {}, { eventID: eventId });
};

// Tests only: forget the counted route
export const resetMetaRouteForTests = () => {
  lastPath = null;
};
